
export const checkOztixDeveloperCookie = function (): boolean {
    const cookies = document.cookie
        .split(";")
        .map((v) => v.trim().split("=")[0]);
    return cookies && cookies.includes("ot_developer");
};